import React from 'react';
import { ButtonSecondary, IconChevronDown, IconChevronUp, } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { NotificationIndicator } from '../components/NotificationIndicator';
const Container = styled.div `
  position: fixed;
  z-index: 9998;
  bottom: var(--pt-minimize-bottom);
  right: var(--pt-chatbox-right);

  @media screen and (max-width: 768px) {
    right: 2rem;
  }
  button[aria-label='Minimize button'] {
    border: 1px solid transparent;
  }
`;
const ButtonStyled = styled(ButtonSecondary) `
  color: ${props => props.$color || '#fff'};
  font-size: 0.8125rem;
  background-color: ${props => props.$backgroundColor || '#3629ed'};
`;
export const MinimizeFAB = ({ minimized, onClick, notifications = 0, backgroundColor, color, }) => (React.createElement(Container, null,
    React.createElement(ButtonStyled, { "aria-label": "Minimize button", iconOnly: () => (minimized ? React.createElement(IconChevronUp, null) : React.createElement(IconChevronDown, null)), onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(minimized), "data-testid": "chat-box-minimize-button", "$backgroundColor": backgroundColor, "$color": color }),
    notifications > 0 ? (React.createElement(NotificationIndicator, { "data-testid": "chat-box-notification" }, notifications)) : null));
